module.exports = __webpack_public_path__ + "img/18.41d5eced.jpg";